<template>
    <Dialog :value="value" @input="$listeners.input" :unlimit-height="true" :title="'ALTERAR FORMA DE PAGAMENTO'" width="1000" :show-close-button="true">
        <FormaPagamentoComponent :value="pedido" :from-alterar="true" :propostas-selecionadas="propostasSelecionadas" @fechar="fecharDialog()" />
    </Dialog>
</template>

<script>
  import FormaPagamentoComponent from '@/components/FormaPagamentoComponent'
  export default {
    name: 'DialogFormaPagamento',
    components: { FormaPagamentoComponent },
    props: {
      pedido: {
        type: Object,
        required: true
      },
      value: Boolean,
      propostasSelecionadas: {
        type: Array,
        required: false
      }
    },
    data: () => ({
      valor: false
    }),
    methods: {
      fechar () {
        this.$emit('input', false)
      },
      fecharDialog () {
        this.$emit('fechar')
      }
    }
  }
</script>

<style scoped>

</style>
